// extracted by mini-css-extract-plugin
export var chip = "_el-0";
export var filterDropdown = "_el-5";
export var filterItem = "_el-6";
export var icon = "_el-1";
export var removeButton = "_el-3";
export var removeIcon = "_el-4";
export var separator = "_el-2";